<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jIYwhs/tc-custom/9781453252932.jpg?1703707469602" alt="This image is the cover for the book When Last Seen Alive, The Aaron Gunner Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When Last Seen Alive, The Aaron Gunner Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>An encounter at the Million Man March sucks Gunner into an ice-cold missing persons case</b>Elroy Covington should have run. He had traveled to the Million Man March in Washington, DC, looking forward to a new city and new faces. Then in a Dupont Circle restaurant, a twist of fate brought him face to face with a man from his long-forgotten past. Instead of running, Elroy said hello. He never made it home. Eight months later, Elroy’s sister shows up in the Los Angeles office of private detective Aaron Gunner, who traded business cards with Elroy at the march and promptly forgot they ever met. Elroy’s last known location was Los Angeles, and his sister thinks he was coming to see the detective. As he tries to warm up Elroy’s frigid trail, Gunner uncovers ties to a black militant group. The time for brotherhood is over, and finding the vanished marcher will mean getting tough.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gar Anthony Haywood
      </h2>
      
      <p class="authorDescription body article">Gar Anthony Haywood (b. 1954) is the Shamus Award&ndash;winning author of the Aaron Gunner mysteries. Born in Los Angeles, he spent over a decade as a computer technician before first publishing fiction in the 1980s. Influenced by a love for the Los Angeles mysteries of Ross Macdonald, he wrote <i>Fear of the Dark</i> (1987), winning the Shamus Award for best first novel and introducing the tough-nosed Los Angeles detective Aaron Gunner.&#160;Haywood continued the Gunner series through the bestselling <i>All the Lucky Ones Are Dead</i> (2000), and in between Gunner novels produced the two-book Loudermilk pair of seriocomic mysteries. Haywood also wrote two stand-alone thrillers, <i>Man Eater</i> (2003) and <i>Firecracker</i> (2004), under the pseudonym Ray Shannon, finding critical acclaim for both. He has written for newspapers and television, including an adaptation of the Dennis Rodman autobiography, <i>Bad as I Wanna Be</i>. His most recent novels are <i>Cemetery Road</i> (2010) and <i>Assume Nothing</i> (2011).<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9cdd496c